import { EventEmitter } from '@root/Services/EventEmitter';
import { injectable } from 'tsyringe';

@injectable()
export class TagModel {
    public TagValid = new EventEmitter<boolean>(false);
}
